// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/fonts/YekanBakh/css/font.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
h1,
h2,
h3,
h4,
h5,
h6,
input,
label,
div,
span,
button,
a,
p,
i,
ul,
li,
table,
tr,
td,
th,
tbody,
thead,
textarea {
  font-weight: 500;
  font-family: YekanBakh !important;
}

.en {
  font-family: YekanBakh-En !important;
  direction: ltr;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBI,gBAAA;EACA,iCAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,cAAA;EACA,gBAAA;AAAJ","sourcesContent":["@import './assets/fonts/YekanBakh/css/font.css';\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\ninput,\nlabel,\ndiv,\nspan,\nbutton,\na,\np,\ni,\nul,\nli,\ntable,\ntr,\ntd,\nth,\ntbody,\nthead,\ntextarea {\n    font-weight: 500;\n    font-family: YekanBakh !important;\n}\n\n.en {\n    font-family: YekanBakh-En !important;\n    direction: ltr;\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
